const Header = () => {
  return (
    <header>
      <nav>
        <div className="page-title">
          <h1>
            Reports <span>(Overview)</span>
          </h1>
        </div>
      </nav>
    </header>
  );
};

export default Header;
